import classNames from 'classnames';
import React from 'react';

import { TableRow } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { StatisticsTableCell } from '../StatisticsTableCell';

interface StatsData {
  id: string;
  label?: string;
  icon?: JSX.Element;
  data: number | string | JSX.Element | JSX.Element[];
}

interface StatisticsTableRowOwnProps {
  className?: string;
  data: StatsData[];
}

type StatisticsTableRowProps = StatisticsTableRowOwnProps;

const useStyles = makeStyles(() => createStyles({
  root: {},
  data: {
    display: 'flex',
    justifyContent: 'center',
  },
}), { name: 'StatisticsTableRow' });

export function StatisticsTableRow(props: StatisticsTableRowProps) {
  const classes = useStyles(props);
  const { className, data } = props;

  return (
    <TableRow className={classNames(classes.root, className)}>
      {data.map((d) => {
        return (
          <StatisticsTableCell key={d.id}>
            <div className={classes.data}>
              {d.data}
            </div>
          </StatisticsTableCell>
        );
      })}
    </TableRow>
  );
}
